import classNames from 'classnames';
import { TimelineItemState } from 'components/generics/Timeline/index';
import {
  getStyleTimelineItem,
  TimelineItemStyleOptions,
} from 'components/generics/Timeline/utils/style';
import React, { HTMLAttributes } from 'react';
import classes from './index.module.scss';

export interface TimeLineItemCircleType
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  state: TimelineItemState;
  isFirst: boolean;
  isLast: boolean;
  currentStep: number;
  dataLength: number;
  index: number;
  topLineClassName?: string;
  bottomLineClassName?: string;
  circleClassName?: string;
  CircleIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  circleIconClassName?: string;
  stopStep?: boolean;
  options?: Partial<TimelineItemStyleOptions>;
}

const TimelineItemCircle = ({
  state,
  isFirst,
  isLast,
  topLineClassName,
  bottomLineClassName,
  circleClassName,
  className,
  CircleIcon,
  circleIconClassName,
  options,
}: TimeLineItemCircleType) => {
  const {
    topLineClassName: innerTopLineClassName,
    bottomLineClassName: innerBottomLineClassName,
    circleClassName: innerCircleClassName,
    CircleIcon: InnerCircleIcon,
    circleIconClassName: innerCircleIconClassName,
  } = getStyleTimelineItem(state, isFirst, isLast, options);

  const FinalCircleIcon = InnerCircleIcon || CircleIcon;

  return (
    <div className={classNames(classes.container, className)}>
      <div
        className={classNames(
          classes.topLine,
          topLineClassName,
          innerTopLineClassName
        )}
      />
      <div
        className={classNames(
          classes.circle,
          circleClassName,
          innerCircleClassName
        )}
      >
        {FinalCircleIcon && (
          <FinalCircleIcon
            className={classNames(
              circleIconClassName,
              innerCircleIconClassName
            )}
          />
        )}
      </div>
      <div
        className={classNames(
          classes.bottomLine,
          bottomLineClassName,
          innerBottomLineClassName
        )}
      />
    </div>
  );
};

export default TimelineItemCircle;
